// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22jzH","delete":"styles_delete__X6j-l","update":"styles_update__P6tI5","add":"styles_add__1uk6S"};